// src/reducers/pbhrepair.reducer.js

import { pbhRepairConstants } from "../constants";

export function pbhrepair(state = {}, action) {
  if (action && action.type) {
    switch (action.type) {
      // PBH Repairs
      case pbhRepairConstants.PBH_REPAIRS_REQUEST:
        return { retrievingPBH: true };
      case pbhRepairConstants.PBH_REPAIRS_SUCCESS:
        return { orders: action.repairs };
      case pbhRepairConstants.PBH_REPAIRS_FAILURE:
        return {};

      // PBH Repair Details
      case pbhRepairConstants.PBH_REPAIR_DETAILS_REQUEST:
        return { retrievingPBH: true };
      case pbhRepairConstants.PBH_REPAIR_DETAILS_SUCCESS:
        return { orders: action.repairs };
      case pbhRepairConstants.PBH_REPAIR_DETAILS_FAILURE:
        return {};

      // PBH Repairs Search Query
      case pbhRepairConstants.PBH_REPAIRS_SEARCH_REQUEST:
        return { searchingPBH: true };
      case pbhRepairConstants.PBH_REPAIRS_SEARCH_SUCCESS:
        return { orders: action.repairs };
      case pbhRepairConstants.PBH_REPAIRS_SEARCH_FAILURE:
        return {};

      default:
        return state;
    }
  }
}
